import { OfficeConsentContentAdapter } from '../adapters';
import { ConsentsClient } from '../clients';
import { OfficeConsentNotFoundError } from '../errors';
import type { IOfficeConsentContent } from '../types/OfficeConsentContent';
import type { IGetPublicConsentParameters } from '../types/PublicConsent.parameters';

export const getPublicConsent = async (
  params: IGetPublicConsentParameters,
): Promise<IOfficeConsentContent> => {
  try {
    const apiResponse = await ConsentsClient.getPublicConsent(params);

    return OfficeConsentContentAdapter.toOfficeConsentContent(apiResponse);
  } catch (e) {
    const officeConsentNotFound = OfficeConsentNotFoundError.fromAxiosError(e);
    if (officeConsentNotFound) {
      throw officeConsentNotFound;
    }

    throw e;
  }
};
